<div class="content">

  <a class="bem-app-lessons-in-chapters-list__back"
    role="button"
    [routerLink]="parentPageUrl">
    @if (isChapterLoading$ | async) {
      <mat-spinner></mat-spinner>
    }
    <mat-icon svgIcon="back"></mat-icon>
    {{chapterName$ | async}}
  </a>

  @if (lessonsWithAssignments$ | async; as lessonsWithAssignments) {
    @for (batch of lessonsWithAssignments; track batch) {
      <app-button-list-card [title]="batch.lesson.get('metadatas').title"
        [buttons]="getChildrenAsButtons(batch)">
      </app-button-list-card>
    }
  } @else {
    <mat-spinner></mat-spinner>
  }


</div>